import api from './api';

/**
 * Servicio para gestionar reportes
 */
export const reportesService = {
  /**
   * Obtener reporte de ventas por sucursal
   * @param {number} sucursalId - ID de la sucursal para filtrar (opcional)
   * @param {number} empresaId - ID de la empresa para filtrar (opcional)
   * @param {string} fechaDesde - Fecha desde (opcional)
   * @param {string} fechaHasta - Fecha hasta (opcional)
   */
  getReporteVentas: async (sucursalId = null, empresaId = null, fechaDesde = null, fechaHasta = null) => {
    const params = {};
    if (sucursalId) params.sucursalId = sucursalId;
    if (empresaId) params.empresaId = empresaId;
    if (fechaDesde) params.fechaDesde = fechaDesde;
    if (fechaHasta) params.fechaHasta = fechaHasta;
    const response = await api.get('/reportes/ventas', { params });
    return response;
  },

  /**
   * Obtener reporte de inventario
   * @param {number} sucursalId - ID de la sucursal para filtrar (opcional)
   * @param {number} empresaId - ID de la empresa para filtrar (opcional)
   * @param {boolean} soloStockBajo - Solo productos con stock bajo (opcional)
   */
  getReporteInventario: async (sucursalId = null, empresaId = null, soloStockBajo = null) => {
    const params = {};
    if (sucursalId) params.sucursalId = sucursalId;
    if (empresaId) params.empresaId = empresaId;
    if (soloStockBajo !== null) params.soloStockBajo = soloStockBajo;
    const response = await api.get('/reportes/inventario', { params });
    return response;
  },

  /**
   * Obtener reporte de ventas por producto
   * @param {number} productoId - ID del producto para filtrar (opcional)
   * @param {number} sucursalId - ID de la sucursal para filtrar (opcional)
   * @param {number} empresaId - ID de la empresa para filtrar (opcional)
   * @param {string} fechaDesde - Fecha desde (opcional)
   * @param {string} fechaHasta - Fecha hasta (opcional)
   */
  getReporteVentasPorProducto: async (productoId = null, sucursalId = null, empresaId = null, fechaDesde = null, fechaHasta = null) => {
    const params = {};
    if (productoId) params.productoId = productoId;
    if (sucursalId) params.sucursalId = sucursalId;
    if (empresaId) params.empresaId = empresaId;
    if (fechaDesde) params.fechaDesde = fechaDesde;
    if (fechaHasta) params.fechaHasta = fechaHasta;
    const response = await api.get('/reportes/ventas-producto', { params });
    return response;
  },
};

